import { SearchResultItemDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Receipt } from '@mui/icons-material';
import { DeliveryTypeIcon } from './delivery-type-icon.component';
import { ResultItemRow } from './result-item-row.component';
import { ResultStatusColumn } from './result-status-column.component';
import { dataString, resultDateLine } from '../search.utils';

export function OrderResultItem({
  item,
  href,
  onClick
}: {
  item: SearchResultItemDto;
  href?: string;
  onClick?: () => void;
}) {
  const recipientName = dataString(item.data, 'recipientName');
  const orderNumber = dataString(item.data, 'orderNumber');
  const primary = recipientName ?? (orderNumber ? `#${orderNumber}` : item.label);

  return (
    <ResultItemRow
      icon={<DeliveryTypeIcon subType={item.subType} Fallback={Receipt} />}
      primary={primary}
      secondaryLines={[
        recipientName && orderNumber ? `#${orderNumber}` : undefined,
        dataString(item.data, 'hubName'),
        resultDateLine(item.data)
      ]}
      trailing={<ResultStatusColumn data={item.data} statusKey="status" />}
      href={href}
      onClick={onClick}
    />
  );
}
